import { render } from "./odn-modal-file.vue?vue&type=template&id=27b22f5c"
import script from "./odn-modal-file.vue?vue&type=script&lang=js"
export * from "./odn-modal-file.vue?vue&type=script&lang=js"

import "./odn-modal-file.vue?vue&type=style&index=0&id=27b22f5c&lang=scss"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__